<template>
  <v-container fluid id="em" :style="'padding: 68px 0px 12px ' + (drawer ? 200 : 0) + 'px;'">
    <v-row
      style="background-color: #f8f8f8; padding: 0 0 10px 10px; width:100%;"
      v-if="!apiLoading"
    >
      <v-col cols="12" class="d-flex justify-start align-center">
				<h2 v-if="currentModule.title" class="text-truncate">
          {{ $t(currentModule.title) }}
          <!--<v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon color="grey lighten-1" style="cursor:pointer;" class="pl-1 pointer" dense v-bind="attrs" v-on="on">mdi-info</v-icon>
                            </template>
                            <span>{{st(currentModule.description)}}</span>
          </v-tooltip>-->
        </h2>
      </v-col>
    </v-row>

    <v-row v-if="apiLoading">
      <v-col cols="12">
        <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row style="padding-top:0; margin-top: -24px;" v-if="!apiLoading">
      <v-col cols="12" v-if="this.accessAllowed">
        <EntityWrapper
          ref="entityWrapper"
          :config="currentModule"
          :context="context"
          @edit-action="(action) => onEditAction(item, index, action)" 
					@refresh="$emit('refresh')" 
					@show-alert="$emit('show-alert', $event)"
        />
      </v-col>
      <!--<v-col cols="12" v-if="!this.accessAllowed">
                <div class="transparent empty-state center-align">
                    <div class="mx-auto align-center d-flex flex-column" style="width: 100%;">
                        <div class="text-center">
                            <i class="large material-icons" style="cursor: pointer;">table_chart</i>
                            <h4>{{ $t('wkt.admin.em.main.empty-title') }}</h4>
                            <p>{{ $t('wkt.admin.em.main.empty-subtitle') }}</p>
                        </div>
                    </div>
                </div>
      </v-col>-->
    </v-row>

    <v-snackbar v-model="showAlert" :timeout="alertTimeout" :color="alertColor">
      <span style="color: #ffffff;">{{alertText}}</span>
      <v-btn text @click="showAlert=false">
        <span style="color: #ffffff;">{{$t('common.dialog-buttons.close')}}</span>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import BaseModule from "../common/BaseModule.js";
import EntityWrapper from "../em/EntityWrapper.vue";
import api from "../../api/humanway.js";
import { EventBus } from "../util/event-bus.js";

export default {
  name: "EMModule",
  mixins: [BaseModule],
  props: ["drawer"],
  components: {
    EntityWrapper,
  },
  data() {
    return {
      allModules: [],
      accessAllowed: true,
      showAlert: false,
      alertColor: "error",
      alertText: "",
      moduleId: null,
      alertTimeout: 3000,
      apiLoading: false,
      moduleLoading: false,
      context: {},
      currentModule: {},
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.$vue.$on("show-module", this.showModule);
      window.$vue.$on("refresh-module", this.refreshModule);
    });
  },
  methods: {
		goBackToFormsModule() {
			EventBus.$emit("hide-form-submissions-module");
		},
    getModules() {
      if (this.moduleLoading) {
        return;
      }
      this.apiLoading = true;
      this.moduleLoading = true;

      api.getModules(
        (data) => {
          this.allModules = data.entities;
          this.moduleLoading = false;
          this.loadModule();
        },
        (err) => {
          this.moduleLoading = false;
          this.apiLoading = false;
          console.log(err);
          this.$emit("show-alert", { text: err.message, color: "error" });
        }
      );
    },
    refreshModule() {
      this.$refs.entityWrapper.refreshData();
    },
    loadModule() {
      let module = this.allModules.find((m) => m.id == this.moduleId);
      this.currentModule = module ? module : {};

      this.apiLoading = false;
    },
    onReveal(payload) {
      if (
        /*this.mustRefresh() ||*/ !this.allModules ||
        this.allModules.length == 0
      ) {
        // Primer acceso
        this.moduleId = payload.moduleId;
        this.getModules();
        //this.context=payload;
      } else if (this.moduleId != payload.moduleId) {
        // hemos cambiado de módulo
        this.moduleId = payload.moduleId;
        this.loadModule();
        this.context = payload;
      } /*else {
            this.context=payload; // se han actualizado los filtros globales
        }*/
    },
  },
};
</script>